var map = {
  "./pl-PL/grafana.json": [
    "619388",
    [
      74573
    ]
  ],
  "./de-DE/grafana.json": [
    "523082",
    [
      71479
    ]
  ],
  "./id-ID/grafana.json": [
    "510130",
    [
      4495
    ]
  ],
  "./fr-FR/grafana.json": [
    "935648",
    [
      75545
    ]
  ],
  "./en-US/grafana.json": [
    "619521",
    [
      47738
    ]
  ],
  "./it-IT/grafana.json": [
    "46834",
    [
      80783
    ]
  ],
  "./nl-NL/grafana.json": [
    "691716",
    [
      21445
    ]
  ],
  "./cs-CZ/grafana.json": [
    "507299",
    [
      28640
    ]
  ],
  "./ja-JP/grafana.json": [
    "637681",
    [
      11114
    ]
  ],
  "./pt-BR/grafana.json": [
    "612288",
    [
      92441
    ]
  ],
  "./pt-PT/grafana.json": [
    "137996",
    [
      91645
    ]
  ],
  "./zh-Hans/grafana.json": [
    "929538",
    [
      86015
    ]
  ],
  "./hu-HU/grafana.json": [
    "323466",
    [
      66167
    ]
  ],
  "./ru-RU/grafana.json": [
    "788018",
    [
      28239
    ]
  ],
  "./es-ES/grafana.json": [
    "170680",
    [
      95553
    ]
  ],
  "./sv-SE/grafana.json": [
    "951579",
    [
      71912
    ]
  ],
  "./ko-KR/grafana.json": [
    "343303",
    [
      89068
    ]
  ],
  "./tr-TR/grafana.json": [
    "246208",
    [
      76025
    ]
  ],
  "./zh-Hant/grafana.json": [
    "414791",
    [
      96204
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 393690;
module.exports = __rspack_async_context;
